import React from 'react'
import { formatLength, getPricePeriodText } from 'common/Utils'
import { Product } from 'common/Products/types'
import { ProductCard } from './index'

const PlanSummary = ({ plan }: { plan: Product }) => (
  <ProductCard horizontal>
    <ProductCard.Header color={plan.colour}>
      <h4>
        {plan.title} - {formatLength(plan.length, plan.length_unit)}
      </h4>
    </ProductCard.Header>
    <ProductCard.Content>
      <h4>{plan.data_gb} GB</h4>
      {getPricePeriodText(plan.is_flex)}
    </ProductCard.Content>
    <div style={{ textAlign: 'left' }}>
      <h4>Unlimited</h4>
      Standard Calls &amp; Texts to <br /> Australia and New Zealand
    </div>
  </ProductCard>
)

export default PlanSummary
